import React from "react";
import PolicyLayout, { PolicySection } from "../components/PolicyLayout";

const SECTIONS = [
  { id: "acceptance",   label: "Acceptance"             },
  { id: "eligibility",  label: "Eligibility"            },
  { id: "age",          label: "Age Restriction"        },
  { id: "orders",       label: "Orders & Payment"       },
  { id: "delivery",     label: "Delivery"               },
  { id: "returns",      label: "Returns & Refunds"      },
  { id: "compliance",   label: "Product Compliance"     },
  { id: "liability",    label: "Limitation of Liability"},
  { id: "ip",           label: "Intellectual Property"  },
  { id: "changes",      label: "Changes to Terms"       },
  { id: "contact",      label: "Contact"                },
];

export default function TermsAndConditions() {
  return (
    <PolicyLayout
      title="Terms & Conditions"
      description="Terms and conditions governing use of Khoja Distributions wholesale platform and services."
      canonical="https://www.khojadistributions.com/terms"
      sections={SECTIONS}
    >
      <PolicySection id="acceptance" title="1. Acceptance of Terms">
        <p>By accessing or using the Khoja Distributions website and wholesale platform at www.khojadistributions.com, you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our platform.</p>
        <p>These terms apply to all visitors, wholesale account holders, and any other users of the platform.</p>
      </PolicySection>

      <PolicySection id="eligibility" title="2. Wholesale Account Eligibility">
        <p>Access to wholesale pricing and ordering is restricted to verified business accounts. By applying for a wholesale account, you represent that you are a licensed retailer or business entity authorized to purchase and resell the products available on our platform.</p>
        <p>Khoja Distributions reserves the right to approve or deny any wholesale account application at its sole discretion.</p>
      </PolicySection>

      <PolicySection id="age" title="3. Age Restriction">
        <p>Many products sold through Khoja Distributions, including tobacco products, vaping devices, and related items, are age-restricted. By using this platform, you confirm that you are 21 years of age or older and that all products purchased will be sold in compliance with applicable federal, state, and local age verification laws.</p>
        <p><strong>NOT FOR SALE TO MINORS.</strong> It is the retailer's responsibility to comply with all applicable age verification requirements at the point of sale.</p>
      </PolicySection>

      <PolicySection id="orders" title="4. Orders & Payment">
        <p>All orders placed through the platform are subject to product availability and confirmation by Khoja Distributions. We reserve the right to cancel or modify any order due to stock availability, pricing errors, or other circumstances.</p>
        <p>Prices are subject to change without notice. The price displayed at the time of order confirmation is the price you will be charged.</p>
      </PolicySection>

      <PolicySection id="delivery" title="5. Delivery">
        <p>Khoja Distributions offers local delivery across the DFW metroplex and surrounding areas of Texas. Delivery timelines of 1–2 business days are estimates and are not guaranteed. We are not liable for delays caused by circumstances outside our control.</p>
        <p>Delivery availability and coverage area may vary. Contact us to confirm delivery to your location before placing an order.</p>
      </PolicySection>

      <PolicySection id="returns" title="6. Returns & Refunds">
        <p>All sales are final unless a product is received in a damaged or defective condition. Claims for damaged or incorrect orders must be reported within <strong>48 hours</strong> of delivery with supporting photos.</p>
        <p>Approved returns or replacements are at the sole discretion of Khoja Distributions. We do not accept returns on tobacco, vaping, or age-restricted products once delivered.</p>
      </PolicySection>

      <PolicySection id="compliance" title="7. Product Compliance">
        <p>It is the sole responsibility of the purchasing retailer to ensure compliance with all federal, state, and local laws regarding the sale, display, and distribution of products purchased from Khoja Distributions. This includes but is not limited to age verification laws, licensing requirements, and health and safety regulations.</p>
        <p>Khoja Distributions makes no representations or warranties regarding the legal status of any product in any specific jurisdiction.</p>
      </PolicySection>

      <PolicySection id="liability" title="8. Limitation of Liability">
        <p>To the fullest extent permitted by law, Khoja Distributions shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our platform or products purchased through it.</p>
        <p>Our total liability for any claim arising from these terms or your use of our platform shall not exceed the amount paid for the specific order giving rise to the claim.</p>
      </PolicySection>

      <PolicySection id="ip" title="9. Intellectual Property">
        <p>All content on this website, including text, images, logos, and design, is the property of Khoja Distributions and may not be reproduced, distributed, or used without express written permission.</p>
      </PolicySection>

      <PolicySection id="changes" title="10. Changes to Terms">
        <p>Khoja Distributions reserves the right to update these Terms and Conditions at any time. Continued use of the platform after changes are posted constitutes acceptance of the revised terms.</p>
      </PolicySection>

      <PolicySection id="contact" title="11. Contact">
        <p>If you have questions about these Terms and Conditions, contact us at:</p>
        <p>
          <strong>Khoja Distributions</strong><br />
          Dallas, TX<br />
          Phone: <a href="tel:2146356340" className="text-accent hover:underline">(214) 635-6340</a><br />
          Email: <a href="mailto:khojadistributions@gmail.com" className="text-accent hover:underline">khojadistributions@gmail.com</a>
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}
